var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #dc1e37;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.77,94.88c-9.4,0-17.44-3.26-24.13-9.77-6.69-6.51-10.2-14.48-10.52-23.89h6.53c.3,7.62,3.15,14.06,8.55,19.32,5.4,5.25,11.92,7.88,19.58,7.88s14.77-2.79,20.32-8.38c5.55-5.59,8.32-12.38,8.32-20.36s-2.8-14.51-8.39-19.95c-5.59-5.44-12.34-8.16-20.25-8.16-4.42,0-8.56,1.01-12.41,3.04-3.86,2.02-7.18,4.74-9.96,8.14h10.35v6.46h-21.27v-21.19h6.47v9.88c3.34-4.01,7.34-7.14,12.01-9.4,4.67-2.26,9.61-3.39,14.82-3.39,4.85,0,9.4.91,13.66,2.73,4.26,1.82,7.98,4.3,11.15,7.43,3.18,3.13,5.69,6.8,7.53,11.01,1.84,4.21,2.76,8.74,2.76,13.58s-.92,9.39-2.76,13.65c-1.84,4.25-4.35,7.96-7.53,11.11-3.18,3.15-6.9,5.65-11.15,7.49-4.26,1.84-8.81,2.76-13.66,2.76h0ZM71.67,75.96l-14.87-14.73v-20.8h6.47v18.15l13,12.79-4.59,4.59h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.62346616cb7b1548dc1e96b68a066279.svg";
export { ForwardRef as ReactComponent };